import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IAtxPopConfirm } from '../interfaces/atx-pop-confirm.interface';
import { DEFAULT_CONFIG } from '../constants/index';

@Component({
    selector: 'atx-pop-confirm',
    template: `<nz-popconfirm [nzTitle]="title"
               [nzOkText]="config?.okText"
               [nzCancelText]="config?.cancelText"
               [nzPlacement]="config?.placement"
               (nzOnConfirm)="fireConfirm.emit($event)"
               (nzOnCancel)="fireCancel.emit($event)">
    <a [class]="config?.clazz" atx-pop-confirm>
        {{ config?.label }}
    </a>
</nz-popconfirm>
`,
    styles: [`:host ::ng-deep .demo{overflow:auto}:host ::ng-deep .ant-popover-wrap>a{margin-right:8px}:host ::ng-deep .ant-btn{margin-right:8px;margin-bottom:8px;width:70px;text-align:center;padding:0}`],
})

export class AtxPopConfirmComponent implements OnInit {
    @Input() public readonly title: string;

    @Input() public config: IAtxPopConfirm;

    @Output('onCancel') public readonly fireCancel: EventEmitter<void> = new EventEmitter();
    @Output('onConfirm') public readonly fireConfirm: EventEmitter<void> = new EventEmitter();

    public ngOnInit() {
        this.config = { ...DEFAULT_CONFIG, ...this.config };
    }
}
